<div *ngIf="session" class="w-full lg:max-w-full lg:flex login-page">
  <div
    class="min-h-screen w-full flex items-center bg-no-repeat pt-6 card-form"
    style="
      background-image: url(&quot;assets/img/FORMULAIRE-INSCRIPTION.png&quot;);
      background-size: cover;
      background-position: 80% center;
      background-attachment: fixed;
      background-color: #1a5f8b;
    "
  >
    <div
      class="w-full px-2 md:px-4 ml-0 lg:ml-12 flex lg:justify-start justify-center"
    >
      <div class="w-[95%] lg:w-3/4 max-w-[850px]">
        <app-card-form style="opacity: 1">
          <div id="page-one" *ngIf="pageOne">
            <div class="flex justify-between mb-10">
              <div
                class="logo-icon"
                style="
                  background-image: url(&quot;assets/img/logo_unchk.png&quot;);
                "
              ></div>
              <div
                class="logo-icon"
                style="
                  background-image: url(&quot;assets/img/logo_master_card.png&quot;);
                "
              ></div>
            </div>
            <div class="flex justify-center items-center">
              <div class="text-center">
                <span class="font-bold text-2xl">
                  FORMULAIRE DE CANDIDATURE
                </span>
                <br />
                Certificat de compétences en {{ appelName }}
                Programme Force-N
              </div>
            </div>
            <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
            <div class="flex justify-center mb-10">
              <img
                src="assets/img/FN-LOGO.png"
                alt="logo"
                class="w-32 h-auto"
              />
            </div>

            <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
            <div class="flex justify-center items-center">
              <div class="text-center">
                <span class="underline text-blue-800">
                  <a
                    href="https://www.force-n.sn/index.php/catalogue"
                    target="_blank"
                    >Vous souhaitez en savoir plus avant de candidater ? Cliquez
                    ici pour obtenir plus de détails sur ce programme.</a
                  >
                </span>
                <br />
                <br />
                <br />
                <span class="font-bold text-2xl">
                  Délai limite pour le dépôt des dossiers de candidature
                </span>
                <br />
                <br />
                {{ appelCloseDate | date: "EEEE d MMMM y, à " }} 23h:59mn
              </div>
            </div>
          </div>

          <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
            <form [formGroup]="soumissionForm" class="space-y-6">
              <div *ngIf="pageOne">
                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
                <div class="flex justify-between gap-2 my-6">
                  <span class="font-bold text-xl md:text-2xl"
                    >I. INFORMATIONS PERSONNELLES</span
                  >
                </div>
                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 m-0">
                  <div class="hidden md:block relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Prénom - Nom
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="
                          isFieldInvalid('firstname') ||
                          isFieldInvalid('lastname')
                        "
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <label
                      for="prenom"
                      class="block md:hidden font-semibold mb-1"
                    >
                      Prénom <span style="color: red">*</span>
                      <span
                        *ngIf="isFieldInvalid('firstname')"
                        class="text-xs ml-2"
                        style="color: #eb1c1c"
                        >(Requis)</span
                      >
                    </label>
                    <input
                      type="text"
                      id="prenom"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="firstname"
                      [style.border]="
                        isFieldInvalid('firstname') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <div class="hidden md:block mt-1 text-sm text-gray-600">
                      <p>Prénom</p>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <label for="nom" class="block md:hidden font-semibold mb-1">
                      Nom <span style="color: red">*</span>
                      <span
                        *ngIf="isFieldInvalid('lastname')"
                        class="text-xs ml-2"
                        style="color: #eb1c1c"
                        >(Requis)</span
                      >
                    </label>
                    <input
                      type="text"
                      id="nom"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                      formControlName="lastname"
                      [style.border]="
                        isFieldInvalid('lastname') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <div class="hidden md:block mt-1 text-sm text-gray-600">
                      <p>Nom</p>
                    </div>
                  </div>
                </div>
                <div class="relative">
                  <div
                    class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                  >
                    <div class="relative z-0 w-full group">
                      <div class="col-span-1 label">
                        <div class="lg:me-3 font-semibold lg:font-normal">
                          Date de naissance
                          <span style="color: red">*</span>
                        </div>
                        <div
                          *ngIf="isFieldInvalid('selectedDate')"
                          style="color: #eb1c1c"
                        >
                          Champ requis !
                        </div>
                      </div>
                    </div>
                    <div class="lg:col-span-2">
                      <div
                        class="flex flex-col sm:flex-row justify-between gap-3"
                      >
                        <div class="w-full">
                          <input
                            type="date"
                            formControlName="selectedDate"
                            id="year"
                            class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                            [style.border]="
                              isFieldInvalid('selectedDate')
                                ? '2px solid #eb1c1c'
                                : ''
                            "
                          />
                          <div class="mt-2">
                            <p class="text-sm text-gray-600">
                              Saisir votre date de naissance ou vous pouvez
                              directement selectionner la date dans l'agenda.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-6 m-0">
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Sexe
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedSexe')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <div class="flex items-center">
                      <input
                        formControlName="selectedSexe"
                        id="bordered-radio-m"
                        type="radio"
                        value="Homme"
                        name="selectedSexe"
                        class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
                        [style.border]="
                          isFieldInvalid('selectedSexe')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <label
                        for="bordered-radio-m"
                        class="w-full py-3 md:py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >Masculin</label
                      >
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <div class="flex items-center">
                      <input
                        formControlName="selectedSexe"
                        id="bordered-radio-f"
                        type="radio"
                        value="Féminin"
                        name="selectedSexe"
                        class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2"
                        [style.border]="
                          isFieldInvalid('selectedSexe')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <label
                        for="bordered-radio-f"
                        class="w-full py-3 md:py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >Féminin</label
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="hidden md:block relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Numéro de téléphone
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="
                          isFieldInvalid('phoneNumber') ||
                          isFieldInvalid('phoneCode')
                        "
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <label
                      for="phoneCode"
                      class="block md:hidden font-semibold mb-1"
                    >
                      Indicatif pays <span style="color: red">*</span>
                      <span
                        *ngIf="isFieldInvalid('phoneCode')"
                        class="text-xs ml-2"
                        style="color: #eb1c1c"
                        >(Requis)</span
                      >
                    </label>
                    <select
                      id="phoneCode"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
                      formControlName="phoneCode"
                      [style.border]="
                        isFieldInvalid('phoneCode') ? '2px solid #eb1c1c' : ''
                      "
                    >
                      <option
                        *ngFor="let phonecode of phoneCode"
                        [value]="phonecode.phoneCode"
                      >
                        {{ phonecode.phoneCode }}
                      </option>
                    </select>
                    <div class="hidden md:block mt-1 text-sm text-gray-600">
                      <p>Indicatif pays</p>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <label
                      for="phoneNumber"
                      class="block md:hidden font-semibold mb-1"
                    >
                      Numéro de téléphone <span style="color: red">*</span>
                      <span
                        *ngIf="isFieldInvalid('phoneNumber')"
                        class="text-xs ml-2"
                        style="color: #eb1c1c"
                        >(Requis)</span
                      >
                    </label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      placeholder="ex: 221 123456789"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                      formControlName="phoneNumber"
                      onlyNumber
                      [style.border]="
                        isFieldInvalid('phoneNumber') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <div class="hidden md:block mt-1 text-sm text-gray-600">
                      <p>Numéro de téléphone</p>
                    </div>
                  </div>
                </div>
                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Numéro Wave
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('phoneNumberWave')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full md:col-span-2 group">
                    <input
                      type="tel"
                      id="phoneNumberWave"
                      placeholder="ex: 221 123456789"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                      formControlName="phoneNumberWave"
                      onlyNumber
                      [style.border]="
                        isFieldInvalid('phoneNumberWave')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <div class="mt-1 text-sm text-gray-600">
                      <p>
                        Merci de partager votre numéro wave pour les frais de
                        remboursement de transport liés aux activités en
                        présentiel
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Ce numéro est-il disponible sur Whatsapp&nbsp;?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('isWhatsApp')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <div class="flex items-center">
                      <input
                        formControlName="isWhatsApp"
                        id="bordered-radio-w1"
                        type="radio"
                        value="OUI"
                        name="isWhatsApp"
                        class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        [style.border]="
                          isFieldInvalid('isWhatsApp')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <label
                        for="bordered-radio-w1"
                        class="w-full py-3 md:py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >Oui</label
                      >
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <div class="flex items-center">
                      <input
                        formControlName="isWhatsApp"
                        id="bordered-radio-w2"
                        type="radio"
                        value="NON"
                        name="isWhatsApp"
                        class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        [style.border]="
                          isFieldInvalid('isWhatsApp')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <label
                        for="bordered-radio-w2"
                        class="w-full py-3 md:py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >Non</label
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                  *ngIf="showWhatsAppNumberFields"
                >
                  <div class="hidden md:block relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Numéro Whatsapp
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="
                          isFieldInvalid('whatsAppNumber') ||
                          isFieldInvalid('phoneCodeForWhatsApp')
                        "
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <label
                      for="phoneCodeForWhatsApp"
                      class="block md:hidden font-semibold mb-1"
                    >
                      Indicatif Whatsapp <span style="color: red">*</span>
                      <span
                        *ngIf="isFieldInvalid('phoneCodeForWhatsApp')"
                        class="text-xs ml-2"
                        style="color: #eb1c1c"
                        >(Requis)</span
                      >
                    </label>
                    <select
                      id="phoneCodeForWhatsApp"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 sm:text-sm sm:leading-6"
                      formControlName="phoneCodeForWhatsApp"
                      [style.border]="
                        isFieldInvalid('phoneCodeForWhatsApp')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option
                        *ngFor="let phonecode of phoneCodeWhatsapp"
                        [value]="phonecode.phoneCode"
                      >
                        {{ phonecode.phoneCode }}
                      </option>
                    </select>
                    <div class="hidden md:block mt-1 text-sm text-gray-600">
                      <p>Indicatif pays</p>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <label
                      for="whatsAppNumber"
                      class="block md:hidden font-semibold mb-1"
                    >
                      Numéro Whatsapp <span style="color: red">*</span>
                      <span
                        *ngIf="isFieldInvalid('whatsAppNumber')"
                        class="text-xs ml-2"
                        style="color: #eb1c1c"
                        >(Requis)</span
                      >
                    </label>
                    <input
                      type="tel"
                      id="whatsAppNumber"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                      formControlName="whatsAppNumber"
                      onlyNumber
                      [style.border]="
                        isFieldInvalid('whatsAppNumber')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    />
                    <div class="hidden md:block mt-1 text-sm text-gray-600">
                      <p>Numéro de téléphone</p>
                    </div>
                  </div>
                </div>
                <div formGroupName="emailGroup">
                  <div
                    class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                  >
                    <div class="hidden md:block relative z-0 w-full group">
                      <div class="col-span-1 label">
                        <div class="lg:me-3 font-semibold md:font-normal">
                          Adresse email
                          <span style="color: #ff0000">*</span>
                        </div>
                        <div
                          *ngIf="isFieldInvalidForMails('emailGroup.email')"
                          style="color: #eb1c1c"
                        >
                          Champ requis !
                        </div>
                        <div
                          *ngIf="isMailFieldInvalid('email')"
                          style="color: #eb1c1c"
                        >
                          Format de l'email invalide.
                        </div>
                      </div>
                    </div>
                    <div class="md:col-span-2 label">
                      <div class="relative z-0 w-full group">
                        <label
                          for="email"
                          class="block md:hidden font-semibold mb-1"
                        >
                          Adresse email <span style="color: #ff0000">*</span>
                          <span
                            *ngIf="isFieldInvalidForMails('emailGroup.email')"
                            class="text-xs ml-2"
                            style="color: #eb1c1c"
                            >(Requis)</span
                          >
                          <span
                            *ngIf="isMailFieldInvalid('email')"
                            class="text-xs ml-2"
                            style="color: #eb1c1c"
                            >(Invalide)</span
                          >
                        </label>
                        <input
                          type="text"
                          id="email"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                          placeholder="Par ex : monnom@exemple.com"
                          formControlName="email"
                          [style.border]="
                            isFieldInvalid('emailGroup.email')
                              ? '2px solid #eb1c1c'
                              : ''
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mt-6 m-0"
                  >
                    <div class="hidden md:block relative z-0 w-full group">
                      <div class="col-span-1 label">
                        <div
                          *ngIf="
                            isFieldInvalidForMails('emailGroup.confirmEmail')
                          "
                          style="color: #eb1c1c"
                        >
                          Champ requis !
                        </div>
                        <div
                          *ngIf="isMailFieldInvalid('confirmEmail')"
                          style="color: #eb1c1c"
                        >
                          Format de l'email invalide.
                        </div>
                        <div
                          *ngIf="showEmailErrors$ | async"
                          style="color: #eb1c1c"
                        >
                          Mettez des mails identiques !
                        </div>
                      </div>
                    </div>
                    <div class="md:col-span-2 label">
                      <div class="relative z-0 w-full group">
                        <label
                          for="confirmEmail"
                          class="block md:hidden font-semibold mb-1"
                        >
                          Confirmez votre adresse email
                          <span style="color: #ff0000">*</span>
                          <span
                            *ngIf="
                              isFieldInvalidForMails('emailGroup.confirmEmail')
                            "
                            class="text-xs ml-2"
                            style="color: #eb1c1c"
                            >(Requis)</span
                          >
                          <span
                            *ngIf="showEmailErrors$ | async"
                            class="text-xs ml-2"
                            style="color: #eb1c1c"
                            >(Non identiques)</span
                          >
                        </label>
                        <input
                          type="email"
                          id="confirmEmail"
                          class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                          formControlName="confirmEmail"
                          placeholder="Veuillez confirmer votre adresse email"
                          [style.border]="
                            isFieldInvalid('emailGroup.confirmEmail')
                              ? '2px solid #eb1c1c'
                              : ''
                          "
                        />
                        <div class="mt-3">
                          <p class="text-sm text-gray-600">
                            Pour être sûr de bien recevoir nos mails, merci
                            d'utiliser des adresses type Gmail. Évitez les
                            adresses Outlook, Yahoo, Hotmail et
                            professionnelles.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-2 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Nationalité
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedCountry')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <div class="flex items-center">
                      <input
                        formControlName="selectedCountry"
                        id="bordered-radio-nat1"
                        type="radio"
                        value="Sénégal"
                        name="selectedCountry"
                        class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        [style.border]="
                          isFieldInvalid('selectedCountry')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <label
                        for="bordered-radio-nat1"
                        class="w-full py-3 md:py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >Sénégalaise</label
                      >
                    </div>
                  </div>
                  <div class="relative z-0 w-full group">
                    <div class="flex items-center">
                      <input
                        formControlName="selectedCountry"
                        id="bordered-radio-nat2"
                        type="radio"
                        value="Autre"
                        name="selectedCountry"
                        class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500"
                        [style.border]="
                          isFieldInvalid('selectedCountry')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      />
                      <label
                        for="bordered-radio-nat2"
                        class="w-full py-3 md:py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >Autre</label
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                  *ngIf="
                    soumissionForm.get('selectedCountry')?.value != 'Sénégal' &&
                    soumissionForm.get('selectedCountry')?.value != null
                  "
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Précisez votre nationalité
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('otherCountry')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        id="otherCountry"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        formControlName="otherCountry"
                        [style.border]="
                          isFieldInvalid('otherCountry')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let country of countries"
                          [value]="country.name"
                        >
                          {{ country.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="flex justify-between gap-2 my-6">
                  <span class="font-bold text-xl md:text-2xl"
                    >II. SITUATION ACADEMIQUE ET PROFESSIONNELLE</span
                  >
                </div>
                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Statut Actuel
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('professionnalSituation')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group flex flex-col gap-2">
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="jobLess"
                        class="w-5 h-5 m-2 text-blue-600"
                        formControlName="professionnalSituation"
                        value="Diplômé/Sans emploi"
                        name="professionnalSituation"
                      />
                      <label
                        for="jobLess"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Diplômé/Sans emploi</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="student"
                        class="w-5 h-5 m-2 text-blue-600"
                        formControlName="professionnalSituation"
                        value="Etudiant"
                        name="professionnalSituation"
                      />
                      <label
                        for="student"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Etudiant</label
                      >
                    </div>
                  </div>
                  <div class="relative z-0 w-full group flex flex-col gap-2">
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="otherStatus"
                        class="w-5 h-5 m-2 text-blue-600"
                        formControlName="professionnalSituation"
                        value="Autre ( Salarié, non-diplômé, auto-emploi...)"
                        name="professionnalSituation"
                      />
                      <label
                        for="otherStatus"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Autre (Salarié, non-diplômé...)</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="entreprefree"
                        class="w-5 h-5 m-2 text-blue-600"
                        formControlName="professionnalSituation"
                        value="Entrepreneur ou freelance"
                        name="professionnalSituation"
                      />
                      <label
                        for="entreprefree"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Entrepreneur ou freelance</label
                      >
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="showDegreeDiv"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Diplôme le plus élevé obtenu &nbsp;
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedDiplome')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedDiplome"
                        id="diplomes"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedDiplome')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let diplome of diplomes"
                          [value]="diplome.name"
                        >
                          {{ diplome.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="showSeriesDiv"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Précisez votre série au Bac
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedSerie')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedSerie"
                        id="series"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedSerie')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let serie of series"
                          [value]="serie.name"
                        >
                          {{ serie.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="showDisciplineDivBTS"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Discipline DUT/BTS
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedDisciplineForBTS')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedDisciplineForBTS"
                        id="disciplineBts"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedDisciplineForBTS')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let discipline of disciplines"
                          [value]="discipline.name"
                        >
                          {{ discipline.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="showDisciplineDivLicence"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Discipline Licence/Master
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedDisciplineForLicence')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedDisciplineForLicence"
                        id="disciplineLicence"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedDisciplineForLicence')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let discipline of disciplines"
                          [value]="discipline.name"
                        >
                          {{ discipline.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="showDisciplineDivM1"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Discipline Licence/Master [M1]
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedDisciplineForM1')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedDisciplineForM1"
                        id="disciplineM1"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedDisciplineForM1')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let discipline of disciplines"
                          [value]="discipline.name"
                        >
                          {{ discipline.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="showDisciplineDivM2"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Discipline Licence/Master [M2]
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedDisciplineForM2')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedDisciplineForM2"
                        id="disciplineM2"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedDisciplineForM2')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let discipline of disciplines"
                          [value]="discipline.name"
                        >
                          {{ discipline.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="showDisciplineDivDoctorat"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Discipline Doctorat
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedDisciplineForDoctorat')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedDisciplineForDoctorat"
                        id="disciplineDoc"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedDisciplineForDoctorat')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let discipline of disciplines"
                          [value]="discipline.name"
                        >
                          {{ discipline.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="showStudentDiv"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Niveau actuel d'études
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedStudyLevel')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedStudyLevel"
                        id="studyLevel"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedStudyLevel')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let student of students"
                          [value]="student.name"
                        >
                          {{ student.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="showOtherSituationDiv"
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Précisez votre statut
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedOtherStatus')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedOtherStatus"
                        id="otherStatusSelect"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedOtherStatus')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let otherstatus of otherStatus"
                          [value]="otherstatus.name"
                        >
                          {{ otherstatus.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="flex justify-between gap-2 my-6">
                  <span class="font-bold text-xl md:text-2xl"
                    >III. INCLUSION</span
                  >
                </div>
                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Région de résidence
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedRegion')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="md:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="selectedRegion"
                        id="cities"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedRegion')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let region of regions"
                          [value]="region.name"
                        >
                          {{ region.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                  *ngIf="showZoneOfResidenceDiv()"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        Zone de résidence
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedZone')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="lg:col-span-2">
                    <select
                      formControlName="selectedZone"
                      id="zone"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                      [style.border]="
                        isFieldInvalid('selectedZone')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option *ngFor="let zone of zones" [value]="zone.name">
                        {{ zone.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                  *ngIf="showSpecifyDiv()"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        Précisez la région de résidence
                      </div>
                      <div
                        *ngIf="isFieldInvalid('specifyRegion')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="lg:col-span-2">
                    <input
                      formControlName="specifyRegion"
                      id="specifyRegion"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    />
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        Êtes-vous en situation de handicap&nbsp;?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('inHandicapSituation')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="lg:col-span-2">
                    <select
                      formControlName="inHandicapSituation"
                      id="inHandicapSituation"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                      [style.border]="
                        isFieldInvalid('inHandicapSituation')
                          ? '2px solid #eb1c1c'
                          : ''
                      "
                    >
                      <option value="Oui">Oui</option>
                      <option value="Non">Non</option>
                    </select>
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                  *ngIf="showHandicapChoiceRadio"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Avez-vous l'un des handicaps suivants ?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="
                          chooseAHandicapMoteur &&
                          chooseAHandicapAuditif &&
                          chooseAHandicapVisuel &&
                          chooseAHandicapAutre
                        "
                        style="color: #eb1c1c"
                      >
                        Choisi un handicap!
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group flex flex-col gap-2">
                    <div class="flex items-center">
                      <input
                        type="checkbox"
                        id="handicapVisuel"
                        class="h-5 w-5 m-2 rounded"
                        formControlName="handicaps_visuel"
                      />
                      <label
                        for="handicapVisuel"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Handicap visuel</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="checkbox"
                        id="handicapMoteur"
                        class="h-5 w-5 m-2 rounded"
                        formControlName="handicaps_moteur"
                      />
                      <label
                        for="handicapMoteur"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Handicap moteur</label
                      >
                    </div>
                  </div>
                  <div class="relative z-0 w-full group flex flex-col gap-2">
                    <div class="flex items-center">
                      <input
                        type="checkbox"
                        id="handicapAuditif"
                        class="h-5 w-5 m-2 rounded"
                        formControlName="handicaps_auditif"
                      />
                      <label
                        for="handicapAuditif"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Handicap auditif</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="checkbox"
                        id="handicapAutre"
                        class="h-5 w-5 m-2 rounded"
                        formControlName="handicaps_autre"
                      />
                      <label
                        for="handicapAutre"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Autre Handicap</label
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        Êtes-vous dans l’une des situations suivantes&nbsp;?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedSituation')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div
                    class="relative z-0 w-full lg:col-span-2 group flex flex-col gap-2"
                  >
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="selectedSituation1"
                        class="w-5 h-5 m-2 text-blue-600"
                        formControlName="selectedSituation"
                        name="selectedSituation"
                        value="Réfugié"
                      />
                      <label
                        for="selectedSituation1"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Réfugié</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="selectedSituation2"
                        class="w-5 h-5 m-2 text-blue-600"
                        formControlName="selectedSituation"
                        name="selectedSituation"
                        value="Déplacé"
                      />
                      <label
                        for="selectedSituation2"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Déplacé</label
                      >
                    </div>
                    <div class="flex items-center">
                      <input
                        type="radio"
                        id="selectedSituation3"
                        class="w-5 h-5 m-2 text-blue-600"
                        formControlName="selectedSituation"
                        name="selectedSituation"
                        value="Non concerné"
                      />
                      <label
                        for="selectedSituation3"
                        class="py-2 text-sm font-medium text-gray-900"
                        >Non concerné</label
                      >
                    </div>
                  </div>
                </div>

                <hr class="h-1 my-8 bg-green-500 border-0 dark:bg-gray-700" />

                <div
                  class="flex justify-center items-center my-4"
                  *ngIf="fillPageOneFields"
                  style="color: #eb1c1c"
                >
                  Veuillez renseigner tous les champs requis !
                </div>

                <div class="flex justify-end items-center">
                  <button
                    type="submit"
                    class="rounded-md w-full md:w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm btn-login"
                    (click)="switchOnPageTwo()"
                  >
                    Suivant
                  </button>
                </div>

                <div class="flex justify-center mt-8">
                  <div
                    class="logo-icon"
                    style="
                      background-image: url(&quot;assets/img/logo_force_n.png&quot;);
                    "
                  ></div>
                </div>
              </div>
              <div id="page-two" *ngIf="pageTwo">
                <div class="flex justify-between gap-2 my-6">
                  <span class="font-bold text-xl md:text-2xl"
                    >IV. MON PROJET</span
                  >
                </div>
                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
                <span class="text-center font-bold block text-sm md:text-base">
                  Pour nous permettre de vous aider au mieux dans la
                  concrétisation de votre projet personnel et professionnel,
                  répondez aux questions suivantes le plus sincèrement possible.
                </span>
                <hr class="h-1 my-8 bg-green-500 border-3 dark:bg-green-700" />

                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Ce parcours d'accompagnement concerne le métier de
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('familyChoice')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div
                    class="relative z-0 w-full md:col-span-2 group flex flex-col gap-2"
                  >
                    <div
                      *ngFor="let family of families"
                      class="flex items-start"
                    >
                      <input
                        id="familyChoice"
                        type="radio"
                        [value]="family.name"
                        formControlName="familyChoice"
                        name="familyChoice"
                        class="w-5 h-5 m-2 text-blue-600 mt-1 md:mt-0"
                      />
                      <label
                        for="familyChoice"
                        class="py-1 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                      >
                        {{ family.name }}
                      </label>
                    </div>
                  </div>
                </div>
                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                <div class="flex justify-between gap-2 my-6">
                  <span class="font-bold text-xl md:text-2xl"
                    >V. CONNAISSANCES & APTITUDES</span
                  >
                </div>
                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                <div
                  *ngFor="let prerequisite of prerequisites; let i = index"
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        {{ prerequisite.name }}
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedPrerequisite_' + i)"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="lg:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        id="prerequisite_{{ i }}"
                        [formControlName]="'selectedPrerequisite_' + i"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedPrerequisite_' + i)
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let bareme of baremes"
                          [value]="bareme.value"
                          class="text-gray-600"
                        >
                          {{ bareme.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  *ngFor="let genericPrerequisite of genList; let i = index"
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        {{ genericPrerequisite.name }}
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('selectedgenPrerequisite_' + i)"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="lg:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        id="genPrerequisite_{{ i }}"
                        [formControlName]="'selectedgenPrerequisite_' + i"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('selectedgenPrerequisite_' + i)
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="
                            let bareme of genericPrerequisite.genPrerequisLabelDTOS
                          "
                          [value]="bareme.label"
                          class="text-gray-600"
                        >
                          {{ bareme.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                <div
                  class="flex justify-center items-center my-4"
                  *ngIf="fillPageTwoFields"
                  style="color: #eb1c1c"
                >
                  Veuillez renseigner tous les champs requis !
                </div>

                <div
                  class="flex flex-col sm:flex-row justify-between gap-4 items-center btn-ctnr"
                >
                  <button
                    type="button"
                    class="rounded-md w-full sm:w-48 h-12 px-3 py-2 text-sm font-semibold text-white bg-gray-500"
                    (click)="goBackOnPageOne()"
                  >
                    Retour
                  </button>
                  <button
                    type="button"
                    class="rounded-md w-full sm:w-48 h-12 px-3 py-2 text-sm font-semibold text-white btn-login"
                    (click)="switchOnPageThree()"
                  >
                    Suivant
                  </button>
                </div>

                <div class="flex justify-center mt-8">
                  <div
                    class="logo-icon"
                    style="
                      background-image: url(&quot;assets/img/logo_force_n.png&quot;);
                    "
                  ></div>
                </div>
              </div>

              <div id="page-three" *ngIf="pageThree">
                <div
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        Quelle disponibilité temps seriez-vous prêt à consacrer
                        au programme Force-N&nbsp;?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('availability')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="lg:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        id="dispo"
                        formControlName="availability"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('availability')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option
                          *ngFor="let timeSlot of availibility"
                          class="text-gray-600"
                          [value]="timeSlot.value"
                        >
                          {{ timeSlot.value }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 my-6 m-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Comment avez-vous connu ce programme&nbsp;?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('mediaSupport')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="relative z-0 w-full group flex flex-col gap-2">
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="mediaSupport_0"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="mediaSupport"
                        value="Sur les réseaux ( Linkedin, Facebook..)"
                      />
                      <label
                        for="mediaSupport_0"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Sur les réseaux (Linkedin, Facebook..)</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="mediaSupport_1"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="mediaSupport"
                        value="Site web UNCHK"
                      />
                      <label
                        for="mediaSupport_1"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Site web UNCHK</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="mediaSupport_2"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="mediaSupport"
                        value="Bouche à oreille"
                      />
                      <label
                        for="mediaSupport_2"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Bouche à oreille</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="mediaSupport_3"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="mediaSupport"
                        value="Autres"
                      />
                      <label
                        for="mediaSupport_3"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Autres</label
                      >
                    </div>
                  </div>
                  <div class="relative z-0 w-full group flex flex-col gap-2">
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="mediaSupport_4"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="mediaSupport"
                        value="TV - Radio"
                      />
                      <label
                        for="mediaSupport_4"
                        class="text-sm font-medium text-gray-900 py-1"
                        >TV - Radio</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="mediaSupport_5"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="mediaSupport"
                        value="Presse écrite"
                      />
                      <label
                        for="mediaSupport_5"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Presse écrite</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="mediaSupport_6"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="mediaSupport"
                        value="Site web partenaires"
                      />
                      <label
                        for="mediaSupport_6"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Site web partenaires</label
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6 my-6 mx-0"
                >
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold lg:font-normal">
                        Êtes vous titulaire d'un certificat du programme
                        Force-N&nbsp;?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('isCertified')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div class="lg:col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <select
                        formControlName="isCertified"
                        class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                        [style.border]="
                          isFieldInvalid('isCertified')
                            ? '2px solid #eb1c1c'
                            : ''
                        "
                      >
                        <option class="text-gray-600" value="OUI">OUI</option>
                        <option class="text-gray-600" value="NON">NON</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:me-3 font-semibold md:font-normal">
                        Votre projet à l’issue du programme&nbsp;?
                        <span style="color: red">*</span>
                      </div>
                      <div
                        *ngIf="isFieldInvalid('yourProject')"
                        style="color: #eb1c1c"
                      >
                        Champ requis !
                      </div>
                    </div>
                  </div>
                  <div
                    class="relative z-0 w-full md:col-span-2 group flex flex-col gap-2"
                  >
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="yourProject_1"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="yourProject"
                        value="Poursuivre mes études"
                      />
                      <label
                        for="yourProject_1"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Poursuivre mes études</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="yourProject_2"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="yourProject"
                        value="Lancer mon entreprise"
                      />
                      <label
                        for="yourProject_2"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Lancer mon entreprise</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="yourProject_3"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="yourProject"
                        value="Chercher un emploi"
                      />
                      <label
                        for="yourProject_3"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Chercher un emploi</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="yourProject_4"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="yourProject"
                        value="Retourner dans mon entreprise"
                      />
                      <label
                        for="yourProject_4"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Retourner dans mon entreprise</label
                      >
                    </div>
                    <div class="flex items-start">
                      <input
                        type="radio"
                        id="yourProject_5"
                        class="w-5 h-5 m-2 text-blue-600 mt-1"
                        formControlName="yourProject"
                        value="Aucun des projets"
                      />
                      <label
                        for="yourProject_5"
                        class="text-sm font-medium text-gray-900 py-1"
                        >Aucun des projets</label
                      >
                    </div>
                  </div>
                </div>

                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
                <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
                  <div class="text-justify text-sm px-2">
                    <input
                      type="checkbox"
                      id="conditions"
                      class="h-5 w-5 m-2 rounded inline-block align-top mt-1"
                      formControlName="conditions"
                      value="Accepté"
                      name="conditions"
                      [style.border]="
                        isFieldInvalid('conditions') ? '2px solid #eb1c1c' : ''
                      "
                    />
                    <span class="inline-block w-[calc(100%-40px)] align-top">
                      En déposant ma candidature, je m'engage si je suis admis à
                      suivre intégralement le parcours d'accompagnement (les
                      certificats de compétences, le renforcement en
                      employabilité, le développement des compétences
                      transversales ...) . Je certifie que l'ensemble des
                      informations communiquées sont exactes et que toute fausse
                      déclaration m'expose à une exclusion du programme.
                      J'autorise FORCE-N à conserver et à utiliser mes données
                      dans le cadre du programme. Les correspondances, les
                      certificats de réussite, l'accès aux plateformes de
                      formation et les badges seront générés à partir des
                      informations personnelles soumises ci-dessous. Veuillez
                      donc fournir des informations correctes et appropriées
                      <span style="color: red">*</span>
                    </span>
                  </div>
                </div>

                <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

                <div
                  class="flex justify-center items-center my-4"
                  *ngIf="allFieldNotSelected"
                  style="color: #eb1c1c"
                >
                  Veuillez renseigner tous les champs requis !
                </div>
                <div
                  class="flex justify-center items-center my-4"
                  *ngIf="isSucces"
                  style="color: #23eb1c"
                >
                  Candidature reussie!
                </div>

                <div
                  class="flex flex-col sm:flex-row justify-between gap-4 items-center btn-ctnr"
                >
                  <button
                    type="button"
                    class="rounded-md w-full sm:w-48 h-12 px-3 py-2 text-sm font-semibold text-white bg-gray-500"
                    (click)="switchOnPageTwo()"
                  >
                    Retour
                  </button>
                  <button
                    type="submit"
                    disabled
                    aria-disabled="true"
                    class="rounded-md w-full sm:w-48 h-12 px-3 py-2 text-sm font-semibold text-white btn-login"
                    (click)="onSubmitForm()"
                  >
                    Envoyer
                  </button>
                </div>

                <div class="flex justify-center mt-8">
                  <div
                    class="logo-icon"
                    style="
                      background-image: url(&quot;assets/img/logo_force_n.png&quot;);
                    "
                  ></div>
                </div>
              </div>
            </form>
          </div>
        </app-card-form>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="noSession"
  class="bg-cover bg-center h-screen w-screen"
  style="
    background-image: url(&quot;assets/img/FORMULAIRE-INSCRIPTION.png&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500">
              Les candidatures sont closes pour cette session. Restez en contact
              avec nous sur
              <a style="color: blue" href="https://force-n.sn/"
                >https://force-n.sn/</a
              >
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="applied"
  class="bg-cover bg-center h-screen w-screen"
  style="
    background-image: url(&quot;assets/img/FORMULAIRE-INSCRIPTION.png&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500">
              Vous avez déjà soumissionné !
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="previousSession"
  class="bg-cover bg-center h-screen w-screen"
  style="
    background-image: url(&quot;assets/img/FORMULAIRE-INSCRIPTION.png&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500">
              Vous êtes déjà dans un parcours
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="admission"
  class="bg-cover bg-center h-screen w-screen"
  style="
    background-image: url(&quot;assets/img/FORMULAIRE-INSCRIPTION.png&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500">
              Vous êtes déjà admis dans ce parcours.
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="isMentor"
  class="bg-cover bg-center h-screen w-screen"
  style="
    background-image: url(&quot;assets/img/FORMULAIRE-INSCRIPTION.png&quot;);
  "
>
  <div
    class="h-full w-full flex items-center justify-center bg-black bg-opacity-50"
  >
    <div
      class="overflow-y-auto overflow-x-hidden fixed z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex"
    >
      <div class="relative p-4 w-full max-w-md max-h-full">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="p-4 md:p-5 text-center">
            <svg
              class="mx-auto mb-4 text-gray-400 w-12 h-12"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 class="mb-5 text-lg font-normal text-gray-500">
              Veuillez utiliser une autre adresse email pour postuler merci !
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="isLoading"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
>
  <div
    class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center gap-4"
  >
    <svg class="animate-spin h-10 w-10 text-orange-500" viewBox="0 0 24 24">
      <circle
        class="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="4"
      ></circle>
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      ></path>
    </svg>
    <span class="text-gray-700 font-semibold">Soumission en cours...</span>
  </div>
</div>
